/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseGetTaskProgressResponse
 */
export interface ResponseGetTaskProgressResponse {
    /**
     * 
     * @type {number}
     * @memberof ResponseGetTaskProgressResponse
     */
    itemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseGetTaskProgressResponse
     */
    statusId?: number;
}

/**
 * Check if a given object implements the ResponseGetTaskProgressResponse interface.
 */
export function instanceOfResponseGetTaskProgressResponse(value: object): value is ResponseGetTaskProgressResponse {
    return true;
}

export function ResponseGetTaskProgressResponseFromJSON(json: any): ResponseGetTaskProgressResponse {
    return ResponseGetTaskProgressResponseFromJSONTyped(json, false);
}

export function ResponseGetTaskProgressResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseGetTaskProgressResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'itemCount': json['item_count'] == null ? undefined : json['item_count'],
        'statusId': json['status_id'] == null ? undefined : json['status_id'],
    };
}

export function ResponseGetTaskProgressResponseToJSON(json: any): ResponseGetTaskProgressResponse {
    return ResponseGetTaskProgressResponseToJSONTyped(json, false);
}

export function ResponseGetTaskProgressResponseToJSONTyped(value?: ResponseGetTaskProgressResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'item_count': value['itemCount'],
        'status_id': value['statusId'],
    };
}

